export default "__VITE_ASSET__Dnzrxel9__"